import UserAvatar from "@/components/lazo-ai-chat-components/Avatar";
import { Colors } from "@/enums/Colors";
import User from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/User";
import { LazoChatConversationShell } from "@/models/ai-chat/LazoChatConversation";
import { ConversationType } from "@/types/ConversationType";
import { Person } from "@mui/icons-material";
import { SxProps, Typography, styled } from "@mui/material";
import Box from "@mui/material/Box";

type Props = {
  chat: LazoChatConversationShell;
};

export function PortalChatAvatar({ chat }: Props) {
  if (!chat || !chat.title) return <></>;
  return (
    <>
      <Box>
        {chat.conversationType === ConversationType.PRIVATE ? (
          <UserAvatar sx={PortalUserAvatarSx} user={{ firstName: chat.title.split(" ")[0], lastName: chat.title.split(" ")[1] } as User} />
        ) : (
          <Avatar
            sx={{ position: "relative", backgroundColor: Colors.BUTTON_SECONDARY_PURPLE, border: `1px solid ${Colors.DARKER_DARKER_GRAY}` }}
          >
            <Person sx={{ fontSize: "2rem" }} />
            <MembersCountContainer>
              <Typography fontSize={"0.625rem"} fontWeight={"500"}>
                {chat.membersCount}
              </Typography>
            </MembersCountContainer>
          </Avatar>
        )}
      </Box>
    </>
  );
}

const Avatar = styled(Box)(() => ({
  width: "40px",
  height: "40px",
  borderRadius: "8px",
  border: Colors.LIGHT_GRAY_8A8E93,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export const PortalUserAvatarSx: SxProps = {
  borderRadius: "0.5rem",
  backgroundColor: Colors.BUTTON_SECONDARY_PURPLE,
  backgroundImage: "none",
  border: `1px solid ${Colors.DARKER_DARKER_GRAY}`,
  color: Colors.ELEGANT_BLACK,
  fontSize: "1.125rem",
};

const MembersCountContainer = styled(Box)(() => ({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "0.25rem",
  height: "1.25rem",
  width: "1.25rem",
  backgroundColor: "#fff",
  border: `1px solid ${Colors.DARKER_DARKER_GRAY}`,
  top: 22,
  left: 22,
}));
